angular.module('Directives')
.directive('bbaInputRadio',

function(){
    return {
        restrict: 'E',
        templateUrl: '/templates/directives/bbaInputRadio.html',
        replace: true,
        scope: {
            name: '@',
            value: '@',
            disabled: '=?',
            checked: '@?',
            class: '@?',
            label: '@?',
            ngModel: '=',
            ngChange: '&'
        },
        controller: bbaInputRadioCtrl
    }

    function bbaInputRadioCtrl($scope, $element, $attrs){
        $scope.testAffix = $attrs.name;
        $scope.isChecked = function(){
            return (typeof($scope.checked) != 'undefined' ? true : false);
        };
    }
});


// WEBPACK FOOTER //
// ./js/directives/bbaInputRadio.js